import type { SxProps, Theme } from '@mui/material/styles';
import React, { useMemo } from 'react';
import EllipsisText from '../../common/components/EllipsisText';

type Location = {
    label?: string | null;
} | null;

type LocationsLabelProps = {
    locations?: Location[];
    sx?: SxProps<Theme>;
};

export default function LocationsLabel({ locations, sx }: LocationsLabelProps) {
    const labels = useMemo(
        () => (locations || []).map((location) => location?.label).filter((label): label is string => Boolean(label)),
        [locations]
    );
    const locationsText = useMemo(() => labels.join(' | '), [labels]);

    if (!locationsText) {
        return null;
    }

    return (
        <EllipsisText
            text={locationsText}
            clampLines={1}
            sx={[
                {
                    display: 'block',
                    width: '100%'
                },
                ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
            ]}
        />
    );
}
